import {
  EntityV2Store,
  ManageCRMStore,
  aguserStore,
  configStore,
  loginStore,
  routerStore,
} from "../../state/CommonState";

import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";

import CustomerPortfolio from "./customerPortfolio";
import MeetingDetails from "./meetingDetails";

import { useSnapshot } from "valtio";

const queryClient = new QueryClient();

const tabs = [
  {
    id: "customerPortfolio",
    label: "Customer Portfolio",
  },
  {
    id: "meetingDetails",
    label: "Meeting Details",
  },
];

const DataTable = (fn) => {
  useSnapshot(ManageCRMStore);
  useSnapshot(routerStore);
  const Entity = EntityV2Store.EntityRec;
  useSnapshot(configStore);
  useSnapshot(aguserStore);
  useSnapshot(loginStore);

  const handleBack = () => {
    fn.fn.fn.fn(false);
  };

  const branchState = Entity?.branch?.[0]?.state || "";
  const country = Entity?.entityCountry || "";
  const location = [branchState, country].filter(Boolean).join(" - ") || "N/A";

  return (
    <div className="w-full flex flex-col gap-3">
      {/* Back button & Title */}
      <div className="flex items-center gap-3 my-1">
        <button
          type="button"
          onClick={handleBack}
          className="hidden sm:flex items-center justify-center p-2 rounded-xl border border-solid border-gray-200 bg-white hover:bg-gray-50 active:scale-95 transition-all text-gray-700 cursor-pointer shadow-2xs"
          title="Back to Entities"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 className="hidden sm:block text-xl sm:text-2xl font-bold text-[#1e293b] tracking-tight">
          Manage CRM
        </h1>
      </div>

      {/* Company Details */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 rounded-2xl bg-white p-4 sm:p-5 border border-solid border-gray-200 shadow-xs">
        <div className="w-full sm:w-auto">
          <div className="flex flex-row w-full justify-between items-center">
            <h2 className="text-lg sm:text-xl font-bold text-[#2B3688] truncate">
              {Entity?.entityName || "Entity"}
            </h2>
            {/* Cross icon - used on mobile to back to screen */}
            <button
              type="button"
              onClick={handleBack}
              className="sm:hidden flex items-center justify-center p-1 text-[#2B3688] hover:text-[#1e293b] border-none bg-transparent cursor-pointer transition-colors"
              title="Close"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="mt-2 flex flex-wrap items-center gap-x-5 gap-y-1 text-xs sm:text-sm text-gray-500">
            <span className="text-[#868686]">
              Entity ID: <strong className="text-gray-800">{Entity?.entityId || "N/A"}</strong>
            </span>

            <span className="text-[#868686]">
              ERP ID: <strong className="text-gray-800">{Entity?.erpnumber || "N/A"}</strong>
            </span>
          </div>
        </div>

        <div className="flex items-center gap-1.5 text-xs sm:text-sm text-[#2B3688] bg-[#EEF2FF] px-3 py-1.5 rounded-lg self-start sm:self-auto font-medium">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-[#2B3688]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0L6.343 16.657a8 8 0 1111.314 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          <span>{location}</span>
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-white border border-solid border-gray-200 rounded-2xl shadow-xs overflow-hidden">
        <div className="p-3 sm:p-5 bg-[#f9fafb]">
          <div className="border-0 border-gray-200 pb-2">
            <div className="flex overflow-x-auto gap-2 no-scrollbar">
              {tabs.map((tab) => (
                <button
                  type="button"
                  key={tab.id}
                  onClick={() => (routerStore.managecrmTabView = tab.id)}
                  className={`px-4 sm:px-6 py-2.5 rounded-xl border-none text-xs sm:text-sm font-semibold transition whitespace-nowrap cursor-pointer ${
                    routerStore.managecrmTabView === tab.id
                      ? "bg-[#E87A1A] text-white shadow-sm"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
          <div className="pt-4">
            {routerStore.managecrmTabView === "customerPortfolio" && (
              <CustomerPortfolio
                activeTab={routerStore.managecrmTabView === "customerPortfolio"}
                fn={fn}
              />
            )}
            {routerStore.managecrmTabView === "meetingDetails" && <MeetingDetails />}
          </div>
        </div>
      </div>
    </div>
  );
};

const ListCrm = (fn) => {
  return (
    <QueryClientProvider client={queryClient}>
      <DataTable fn={fn} />
    </QueryClientProvider>
  );
};

export default ListCrm;
